import * as React from "react"
import {useSignal} from "@preact/signals-react"
import {Box, Grid, Typography} from "@mui/material"

import ProductPagesImagesDetailCatalogueBlock from "./CatalogueBlock"
import ProductPagesImagesDetailImagesBlock from "./ImagesBlock"
import ProductPagesImagesDetailSelectedImage from "./SelectedImage"

import {useProductPageImageDetailsCatalogue} from "../@hooks";
import {productPageImageDetailsDataModal} from "../@signals";
import {PRODUCT_PAGES_IMAGES_DETAILS_CHECK_STATUS} from "../constants";


export default function ProductPagesImagesDetailModalContainer({ keyData }) {
    const { catalogueData, isLoadingCatalogue } = useProductPageImageDetailsCatalogue(productPageImageDetailsDataModal.value)

    const { pos } = productPageImageDetailsDataModal.value
    const images = productPageImageDetailsDataModal.value[keyData]

    const selected = useSignal(parseInt(pos))
    const imageSelected = images[selected.value] || {}

    const selectedCatalogue = useSignal(imageSelected.imageCheckerID)
	const imageShow = selectedCatalogue.value ? catalogueData.find(item => item.imageSkuID === selectedCatalogue.value) : null
    const haveCheck = !!imageSelected && imageSelected.similarity !== null && [PRODUCT_PAGES_IMAGES_DETAILS_CHECK_STATUS.FULL_MATCH, PRODUCT_PAGES_IMAGES_DETAILS_CHECK_STATUS.NO_POSITION_MATCH].includes(imageSelected.checkStatus)

    const imageURL = imageSelected.url

    return <Grid container spacing={2}>
        <Grid item xs={12} sx={{ display: 'flex', gap: 2, alignItems: 'stretch', justifyContent: 'space-evenly' }}>
            <ProductPagesImagesDetailSelectedImage
                url={imageURL}
                text="Retailer Image"
            />
            { !!imageShow && <ProductPagesImagesDetailSelectedImage
                url={imageShow.catalogueURL}
                showIcon={haveCheck && imageSelected.imageCheckerID === imageShow.imageSkuID}
                checkerID={imageSelected.checkStatus}
                text={<Box sx={{ mt: -1 }}>
                <Typography variant="overline" sx={{ display:'block', fontStyle: 'italic', textAlign: 'center', my: 1 }}>
                    Official Image: {imageShow?.name}
                </Typography>
                <Typography variant="overline" sx={{ fontStyle: 'italic', textAlign: 'center', my: 1 }}>
                    {imageShow?.subtitle}
                </Typography>
            </Box>}
            /> }
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', gap: 1, justifyContent: 'center', color: 'text.disabled', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h6">
                Images in Gallery
            </Typography>
            <ProductPagesImagesDetailImagesBlock images={images} selected={selected} selectedCatalogue={selectedCatalogue} showIcon={haveCheck} />
        </Grid>
        <Grid item xs={12}>
            <ProductPagesImagesDetailCatalogueBlock
                skuID={productPageImageDetailsDataModal.value.skuID}
                selected={selectedCatalogue}
                imageShow={imageShow}
                isLoadingCatalogue={isLoadingCatalogue}
                catalogueData={catalogueData}
            />
        </Grid>
    </Grid>
}